import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ReactAuthWrapper } from "@carrier/reactauthwrapper";
import { umAppConfig } from "./appConfig";
import Home from './components/Home';
import EditableTable from './components/EditableTable';
import Footer from './components/Footer';
import Header from './components/Header';
import Ecat from './components/Scm/Scm';
import NotFound from './components/NotFound/NotFound';
import CodeView from './components/CodeView/CodeView';
import API from './components/CodeView/MyApi';
import UserContext from './contexts/UserContext';
import ViperHome from './components/Viper/Home';
import ViperEditableTable from './components/Viper/EditableTable';
import ViperCodeView from './components/Viper/CodeView/CodeView';

function App() {

  const [userInfo, setUserInfo] = useState(null)

  const getUserDetails = async () => {
    const res = await API.getData("/", '');
    setUserInfo(res)
  };

  useEffect( () => {
    getUserDetails();
  },[]);

  return (
    <ReactAuthWrapper appConfig={umAppConfig}>
      <UserContext.Provider value={userInfo}>
        <Router>
          <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header />
            <div style={{ flex: 1 }}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/table" element={<EditableTable />} />
                <Route path="/scm" element={<Ecat />} />
                <Route path="/codeview" element={<CodeView />} />
                <Route path="/table2" element={<EditableTable />} />


                <Route path="/viper" element={<ViperHome />} />
                <Route path="/viper-table" element={<ViperEditableTable />} />
                <Route path="/viper-codeview" element={<ViperCodeView />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
            <Footer />
          </div>
        </Router>
      </UserContext.Provider>
    </ReactAuthWrapper>
  );
}

export default App;